import API from '@/models/API';

export default class PointTitles {
  constructor(item = {}) {
    this.volume = item.volume || null;
    this.card_type = item.card_type || 'qr';
  }

  static get = (query, filters) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/loyalty-cards${query + filters}`);

  static create = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/loyalty-cards`, body);

  static delete = (id) =>
    API.delete(`/companies/${localStorage.getItem('storeId')}/loyalty-cards/${id}`);
}
